<template>
  <div id="voyage-plan-compare">
    <div class="voyage-plan-compare-inner" :class="{'mobile': isMobileDevice}">
      <div class="back-to-list-button-area">
        <router-link :to="{ name: 'addon-eco-ship-voyage-plan-list', query: paramsToList }" class="back-to-list-button">
          <feather-icon icon="ChevronLeftIcon" svgClasses="h-5 w-5" />
          <span>一覧へ戻る</span>
        </router-link>
      </div>
      <div class="main-voyage-plan-container mobile" v-if="isMobileDevice">
        <div class="voyage-plan-map-wrapper">
          <div id="voyage-plan-map">

          </div>
          <div class="data-display-container" v-show="selectedVoyageIndex != null">
            <div class="point-data-area">
              <div class="data-text">{{selectedVoyageData.vesselName}}</div>
              <div class="data-text">{{selectedVoyageData.pilot}}</div>
              <div class="data-text">{{selectedVoyageData.datetime}}</div>
              <div class="data-text">速力：{{displayNumberWithUnit(selectedVoyageData.velocity, "KN")}}</div>
              <div class="data-text">時間：{{convertHourToDisplayHour(selectedVoyageData.elapsedTime)}}</div>
              <div class="data-text">距離：{{displayNumberWithUnit(selectedVoyageData.distance, "NM")}}</div>
              <div class="data-text">平均消費：{{displayNumberWithUnitK(selectedVoyageData.cFuelEconomy, "KL")}}</div>
            </div>
            <div class="report-data-area">
              <div class="data-text">天候：{{selectedVoyageData.weather}}</div>
              <div class="data-text">風向：{{selectedVoyageData.windDirection}}</div>
              <div class="data-text">風力：{{displayNumberWithUnit(selectedVoyageData.windStrength, "m/s")}}</div>
              <div class="data-text">波高：{{displayNumberWithUnit(selectedVoyageData.waveHeight, "m")}}</div>
              <div class="data-text">うねり：{{displayNumberWithUnit(selectedVoyageData.swell, "m")}}</div>
              <div class="data-text">視程：{{displayNumberWithUnit(selectedVoyageData.visibility, "mile")}}</div>
            </div>
          </div>
        </div>

        <div class="voyage-plan-control-container aisea-text-10-400-white">
          <div class="voyage-plan-control-area" :class="{'show-data': selectedVoyageIndex != null}">
            <div
              class="control-area-switch-container"
              :class="{
                selected: selectedVoyageIndex == index,
                first: index == 0,
                last: index == fuelEconomyVoyages.length-1,
                inactive: !visibleVoyages.includes(index)
              }"
              v-for="(voyage, index) in fuelEconomyVoyages" :key="index"
              v-on:mouseover="setFocusedVoyageIndex(index)"
              v-on:mouseleave="setFocusedVoyageIndex(null)"
            >
              <div class="upper-switch-container">
                <span>航路{{index+1}}</span>
                <vs-switch class="control-switch" color="#2D9CDB" v-model="visibleVoyages" :vs-value="index"/>
              </div>
              <div class="focused-route-info-text">{{voyage.dateRange}}</div>
              <div class="focused-route-info-text">{{voyage.destination}}</div>

              <div class="click-event-wrapper" @click="selectVoyage(voyage, index)"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-voyage-plan-container" v-else>
        <div id="voyage-plan-map">

        </div>
        <div class="voyage-plan-control-container aisea-text-10-400-white">
          <div class="voyage-plan-control-area" :class="{'show-data': selectedVoyageIndex != null}">
            <div
              class="control-area-switch-container"
              :class="{
                selected: selectedVoyageIndex == index,
                first: index == 0,
                last: index == fuelEconomyVoyages.length-1,
                inactive: !visibleVoyages.includes(index)
              }"
              v-for="(voyage, index) in fuelEconomyVoyages" :key="index"
              v-on:mouseover="setFocusedVoyageIndex(index)"
              v-on:mouseleave="setFocusedVoyageIndex(null)"
            >
              <div class="upper-switch-container">
                <span>航路{{index+1}}</span>
                <vs-switch class="control-switch" color="#2D9CDB" v-model="visibleVoyages" :vs-value="index"/>
              </div>
              <div class="focused-route-info-text">{{voyage.dateRange}}</div>
              <div class="focused-route-info-text">{{voyage.destination}}</div>

              <div class="click-event-wrapper" @click="selectVoyage(voyage, index)"></div>
            </div>
          </div>
          <transition name="left">
            <div class="data-display-container" v-show="selectedVoyageIndex != null">
              <div class="point-data-area">
                <div class="data-text">{{selectedVoyageData.vesselName}}</div>
                <div class="data-text">{{selectedVoyageData.pilot}}</div>
                <div class="data-text">{{selectedVoyageData.datetime}}</div>
                <div class="data-text">速力：{{displayNumberWithUnit(selectedVoyageData.velocity, "KN")}}</div>
                <div class="data-text">時間：{{convertHourToDisplayHour(selectedVoyageData.elapsedTime)}}</div>
                <div class="data-text">距離：{{displayNumberWithUnit(selectedVoyageData.distance, "NM")}}</div>
                <div class="data-text">平均消費：{{displayNumberWithUnitK(selectedVoyageData.cFuelEconomy, "KL")}}</div>
              </div>
              <div class="report-data-area">
                <div class="data-text">天候：{{selectedVoyageData.weather}}</div>
                <div class="data-text">風向：{{selectedVoyageData.windDirection}}</div>
                <div class="data-text">風力：{{displayNumberWithUnit(selectedVoyageData.windStrength, "m/s")}}</div>
                <div class="data-text">波高：{{displayNumberWithUnit(selectedVoyageData.waveHeight, "m")}}</div>
                <div class="data-text">うねり：{{displayNumberWithUnit(selectedVoyageData.swell, "m")}}</div>
                <div class="data-text">視程：{{
                  displayNumberWithUnit(convertMeterToMile(selectedVoyageData.visibility), "mile")
                  }}</div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import Mapbox from "mapbox-gl";
import moment from "moment";
import LocalDbService from "@/services/localDbService";
import { MAP_STYLE_DEFAULT, MAP_STYLE_SATELLITE } from "@/config/const";
import 'mapbox-gl/dist/mapbox-gl.css'
const { mapActions } = createNamespacedHelpers("ecoShipVoyagePlan");

// Mixins
import {LocalizeMixin, DeviceInfoMixin, LayerMixin} from "@/mixins";

export default {
  mixins: [LocalizeMixin, DeviceInfoMixin, LayerMixin],
  data() {
    return {
      focusedPointInfo: null,
      visibleVoyages: [],
      selectedVoyageData: {
        vesselName: null,
        pilot: null,
        datetime: null,
        velocity: null,
        elapsedTime: null,
        distance: null,
        cFuelEconomy: null,
        swell: null,
        waveHeight: null,
        visibility: null,
        windDirection: null,
        windStrength: null
      },
      selectedVoyageIndex: null,
      focusedVoyageIndex: null,
      fuelEconomyVoyages: [],
      map: null,
      accessToken: process.env.VUE_APP_MAPBOX_TOKEN,
      center: [139.92878, 35.56920],
      zoom: 4,
      mapStyleLocal: null,
      imageDefault: require("@/assets/images/pages/map/streetmap.png"),
      imageSatellite: require("@/assets/images/pages/map/sattellite.png"),
      mapStyle: this.MAP_DEFAULT_STYLE_URL,

      overValueColor: '#F7455D',
      belowValueColor: '#FFFFFF',

      maxVoyageCount: 7, // 7航路まで比較可能

      paramsToList: null
    };
  },
  watch: {
    visibleVoyages(value) {
      const visibleArray = this.fuelEconomyVoyages.map((element, index) => {
        return value.includes(index)
      })
      visibleArray.forEach((element, index) => {
        this.switchVisibility(element, index)
      })

      if (!value.includes(this.selectedVoyageIndex)) this.selectedVoyageIndex = null
    },
    focusedVoyageIndex(newValue, oldValue) {
      let target = newValue != null ? newValue : oldValue
      if (target != this.selectedVoyageIndex) {
        if (newValue == null) {
          this.setLinePropertyFocused(oldValue + '-' + 'route', false)
        } else {
          this.setLinePropertyFocused(newValue + '-' + 'route', true)
        }
      }
    },
    selectedVoyageIndex(newValue, oldValue) {
      if (newValue != null) {
        this.setLinePropertyFocused(newValue + '-' + 'route', true)
      }
      if (oldValue != null) {
        this.setLinePropertyFocused(oldValue + '-' + 'route', false)
      }
    },
  },

  async created() {
    this.deviceInfo = this.getDeviceInfo()
    this.paramsToList = this.$route.params
  },
  async mounted() {
    this.$vs.loading()

    // urlパラメータから対象の航路履歴idを取得、idの重複と数超過を処理
    let ids = this.$route.query.voyageIds
    if (typeof ids == "string") {
      ids = [ids]
    }
    ids = Array.from(new Set(ids))
    ids = ids.slice(0, this.maxVoyageCount)

    const fuelEconomyArray = await this.getVoyageFuelEconomyArray(ids)

    this.fuelEconomyVoyages = await Promise.all(fuelEconomyArray.map(async (element, index)=>{
      this.visibleVoyages.push(index)

      // vesselIdを最初のfromPointから取得
      const vesselId = element.fe.length > 0 ? element.fe[0].fromPoint.vesselId : null

      const vesselName = element.vn
      const dateRange = `${moment(element.sat).format("YYYY/MM/DD")} - ${moment(element.eat).format("YYYY/MM/DD")}`
      const destination = element.rn
      const pilot = element.un

      // timerangeから対象の動静連絡reportを抽出
      let reportRes = null
      let targetReports = null
      if (vesselId) {
        const range_date = `${moment(element.sat).format("YYYY/MM/DD")}-${moment(element.eat).format("YYYY/MM/DD")}`
        let payload = {
          params: {
            range_date: range_date
          },
          path: {
            vesselId: vesselId
          }
        }
        reportRes = await this.getVesselReportList(payload)
        targetReports = reportRes.reports
      }

      // feature生成
      const lineFeatures = this.createLineFeatures(element, index, targetReports)
      const pointFeatures = this.createPointFeatures(element, index)

      return {
        prefix: "voyage-" + index,
        vesselId: vesselId,
        vesselName: vesselName,
        pilot: pilot,

        dateRange: dateRange,
        destination: destination,

        features: lineFeatures,
        pointFeatures: pointFeatures,
        visibleSwitch: true,
        focusMarker: null,
        lineColor: "#F6FB06",
      }

    }));

    this.mapStyleLocal = await LocalDbService.getMapStyle();
    Mapbox.prewarm();
    Mapbox.maxParallelImageRequests = 10;
    Mapbox.accessToken = this.accessToken;
    this.map = new Mapbox.Map({
      container: "voyage-plan-map",
      style: this.mapStyleLocal,
      center: this.center,
      zoom: this.zoom
    });
    this.map.on("style.load", this.mapStyleLoad);

    let scale = new Mapbox.ScaleControl({
      maxWidth: 80,
      unit: "imperial"
    });
    this.map.addControl(scale);
    scale.setUnit("metric");

    // マップスタイル変更ボタン
    const createMapStyleChangerButton = onclick => {
      const button = document.createElement("button");
      button.setAttribute("type", "button");
      button.classList.add("mapboxgl-ctrl-map-style-changer");
      button.appendChild(document.createElement("img"));
      button.children[0].classList.add("mapboxgl-ctrl-icon");
      button.children[0].src = this.imageSatellite;
      button.addEventListener("click", onclick);
      return button;
    };

    const mapStyleChangerButton = createMapStyleChangerButton(_ => {
      this.updateMapStyle();
    });

    const mapStyleChangerControl = {
      onAdd: _ => {
        this._container = document.createElement("div");
        this._container.classList.add("mapboxgl-ctrl", "mapboxgl-ctrl-group");
        this._container.classList.add("custom-control");
        this._container.appendChild(mapStyleChangerButton);
        return this._container;
      },
      getDefaultPosition: () => {
        return "top-right";
      },
      onRemove: () => {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
      }
    };
    this.map.addControl(mapStyleChangerControl);

    let nav = new Mapbox.NavigationControl();
    this.map.addControl(nav, 'bottom-right');

    this.$vs.loading.close()
  },
  computed: {
    isMobileDevice() {
      if (this.deviceInfo) {
        return this.deviceInfo.deviceType == "iPhone"
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions([
      "getVoyageFuelEconomyArray",
      "getVesselReportList"
    ]),
    convertHourToDisplayHour(time) {
      if (time == null) return
      let originalMinutes = Math.abs(time * 60)
      let hour = Math.floor(originalMinutes / 60)
      hour = ( '00' + hour ).slice( -2 )
      let min = Math.round(originalMinutes % 60)
      min = ( '00' + min ).slice( -2 )
      return `${hour}:${min}`
    },
    switchVisibility(visibility, prefix) {
      if (!visibility) {
        if (this.map) {
          this.map.setLayoutProperty(
            prefix + '-' + 'line',
            'visibility',
            'none'
          );
          this.map.setLayoutProperty(
            prefix + '-' + 'route',
            'visibility',
            'none'
          );
          this.map.setLayoutProperty(
            prefix + '-' + 'point',
            'visibility',
            'none'
          );
        }
      } else {
        if (this.map) {
          this.map.setLayoutProperty(
            prefix + '-' + 'line',
            'visibility',
            'visible'
          );
          this.map.setLayoutProperty(
            prefix + '-' + 'route',
            'visibility',
            'visible'
          );
          this.map.setLayoutProperty(
            prefix + '-' + 'point',
            'visibility',
            'visible'
          );
        }
      }
    },
    mapStyleLoad() {
      if (this.isDefaultMapStyle(this.mapStyleLocal)) {
        let lang = this.getBrowserLanguage()
        let local = "name_" + lang;
        if (this.map) {
          let textLayerIds = this.getTextLayerIds();
          textLayerIds.forEach(id => {
            this.map.setLayoutProperty(id, "text-field", ["get", local]);
          });
        }
      }
      this.fuelEconomyVoyages.forEach((element, index) => {
        this.addSource(element, index)
        this.addLayers(element, index)
        this.setMouseEvents(element, index)
      })
    },
    createLineFeatures(fuelEconomyVoyage, voyageIndex, reports) {
      const threshold = fuelEconomyVoyage.th
      const fe = fuelEconomyVoyage.fe

      return fe.map((element, index) => {
        // ポイントの時間と一番近い動静連絡レポートを抽出
        const targetDateValue = moment(element.fromPoint.createdAt).valueOf()
        const report = reports.length > 0 ? reports.reduce(function(prev, curr) {
          return (Math.abs(moment(curr.report_at).valueOf() - targetDateValue) < Math.abs(moment(prev.report_at).valueOf() - targetDateValue) ? curr : prev);
        }) : null
        return {
          type: "Feature",
          properties: {
            index: index,
            voyageIndex: voyageIndex,
            prefix: "voyage-" + voyageIndex,
            id: "voyage-" + voyageIndex + "-line-" + index,
            datetime: moment(element.fromPoint.createdAt).format("YYYY/MM/DD HH:mm"),
            elapsedTime: element.time,
            distance: element.distance,
            cFuelEconomy: element.cFuelEconomy,
            isFuelOverThreshold: threshold < element.fuelEconomy,
            velocity: element.velocity,
            color: threshold < element.fuelEconomy ? this.overValueColor : this.belowValueColor,

            weather: report ? report.weather : null,
            windDirection: report ? report.wind_direction : null,
            windStrength: report ? report.wind_strength : null,
            waveHeight: report ? report.wave_height : null,
            swell: report ? report.swell : null,
            visibility: report ? report.visibility : null
          },
          geometry: {
            'type': 'LineString',
            'coordinates': [[element.fromPoint.longitude, element.fromPoint.latitude], [element.toPoint.longitude, element.toPoint.latitude]]
          }
        }
      })
    },
    createPointFeatures(fuelEconomyVoyage, voyageIndex) {
      const threshold = fuelEconomyVoyage.th
      const fe = fuelEconomyVoyage.fe
      let featureList = fe.map((element, index) => {
        return {
          type: "Feature",
          properties: {
            id: "voyage-" + voyageIndex + "-point-" + index,
            circleColor: threshold < element.fuelEconomy ? this.overValueColor : this.belowValueColor,
            circleStrokeColor: threshold < element.fuelEconomy ? this.overValueColor : this.belowValueColor
          },
          geometry: {
            'type': 'Point',
            'coordinates': [element.fromPoint.longitude, element.fromPoint.latitude]
          }
        }
      })
      return featureList
    },
    addSource(voyage, prefix) {
      let selfVoyage = voyage

      this.map.addSource(prefix + '-' + 'line-source', {
        'type': 'geojson',
        'promoteId': 'id',
        'data': {
          'type': 'FeatureCollection',
          'features': selfVoyage.features
        },
      })

      this.map.addSource(prefix + '-' + 'point-source', {
        'type': 'geojson',
        'promoteId': 'id',
        'data': {
          'type': 'FeatureCollection',
          'features': selfVoyage.pointFeatures
        }
      })

      this.map.addSource(prefix + '-' + 'line-event-source', {
        'type': 'geojson',
        'promoteId': 'id',
        'data': {
          'type': 'FeatureCollection',
          'features': selfVoyage.features
        },
      })
    },
    addLayers(voyage, prefix) {
      this.map.addLayer({
        'id': prefix + '-' + 'route',
        'type': 'line',
        'source': prefix + '-' + 'line-source',
        'layout': {
          'line-join': 'round',
          'line-cap': 'round',
          'visibility': 'visible',
        },
        'paint': {
          'line-color': ['get', 'color'],
          'line-width': 2,
          'line-opacity': 0.6
        }
      });

      this.map.addLayer({
        'id': prefix + '-' + 'point',
        'type': 'circle',
        'source': prefix + '-' + 'point-source',
       'visibility': 'none',
        'paint': {
          'circle-radius': [
            'case',
            ['boolean',['feature-state', 'focused'], false],
            6,
            0
          ],
          'circle-color': ["get", "circleColor"],
          'circle-stroke-color': ["get", "circleStrokeColor"],
          'circle-stroke-width': [
            'case',
            ['boolean',['feature-state', 'focused'], false],
            2,
            0
          ],
          'circle-stroke-opacity': 0.5
        }
      });

      this.map.addLayer({
        'id': prefix + '-' + 'line',
        'type': 'line',
        'source': prefix + '-' + 'line-event-source',
        'layout': {
          'line-join': 'round',
          'line-cap': 'round',
          'visibility': 'visible',
        },
        'paint': {
          "line-width": 20.0,
          "line-opacity": 0
        }
      });
    },
    updateMapStyle() {
      let el = document.getElementsByClassName(
        "mapboxgl-ctrl-map-style-changer"
      );
      if (this.mapStyleType === 1) {
        el[0].lastChild.src = this.imageSatellite;
        this.mapStyleType = 2;
        this.map.setStyle(MAP_STYLE_DEFAULT);
        this.mapStyleLocal = MAP_STYLE_DEFAULT
      } else {
        el[0].lastChild.src = this.imageDefault;
        this.mapStyleType = 1;
        this.map.setStyle(MAP_STYLE_SATELLITE);
        this.mapStyleLocal = MAP_STYLE_SATELLITE
      }
    },
    setMouseEvents(voyage, prefix) {
      this.map.on("mousemove", prefix + '-' + 'line', e => {
        if (this.selectedVoyageIndex == prefix) {
          const featureData = e.features[0].properties
          this.selectedVoyageData.datetime = featureData.datetime != "null" ? featureData.datetime : null
          this.selectedVoyageData.velocity = featureData.velocity != "null" ? featureData.velocity : null
          this.selectedVoyageData.elapsedTime = featureData.elapsedTime != "null" ? featureData.elapsedTime : null
          this.selectedVoyageData.distance = featureData.distance != "null" ? featureData.distance : null
          this.selectedVoyageData.cFuelEconomy = featureData.cFuelEconomy != "null" ? featureData.cFuelEconomy: null

          this.selectedVoyageData.weather = featureData.weather != "null" ?  featureData.weather : null
          this.selectedVoyageData.windDirection = featureData.windDirection != "null" ? featureData.windDirection : null
          this.selectedVoyageData.windStrength = featureData.windStrength != "null" ? featureData.windStrength : null
          this.selectedVoyageData.waveHeight = featureData.waveHeight != "null" ? featureData.waveHeight : null
          this.selectedVoyageData.swell = featureData.swell != "null" ? featureData.swell : null
          this.selectedVoyageData.visibility = featureData.visibility != "null" ? featureData.visibility : null

          if(this.focusedPointInfo) {
            this.map.setFeatureState(this.focusedPointInfo, {
              focused: false
            });
          }
          this.focusedPointInfo = {
            source: featureData.voyageIndex + '-' + 'point-source',
            id: featureData.prefix + '-point-' + featureData.index,
          }
          this.map.setFeatureState({
            source: featureData.voyageIndex + '-' + 'point-source',
            id: featureData.prefix + '-point-' + featureData.index,
          }, {
            focused: true
          });
        }
      })
      this.map.on(
        "mouseleave",
        prefix + '-' + 'line',
        _ => {
          if (this.selectedVoyageIndex == prefix) {
            this.selectedVoyageData.datetime = null
            this.selectedVoyageData.velocity = null
            this.selectedVoyageData.elapsedTime = null
            this.selectedVoyageData.distance = null
            this.selectedVoyageData.cFuelEconomy = null

            this.selectedVoyageData.weather = null
            this.selectedVoyageData.windDirection = null
            this.selectedVoyageData.windStrength = null
            this.selectedVoyageData.waveHeight = null
            this.selectedVoyageData.swell = null
            this.selectedVoyageData.visibility = null

            this.map.setFeatureState(this.focusedPointInfo, {
              focused: false
            });
          }
        }
      );
    },

    setCursor(isPointer, self) {
      self.map.getCanvas().style.cursor = isPointer ? "pointer" : "";
    },

    roundNumber(number) {
      if (typeof number == "number") {
        return Math.round(number * 100) / 100
      } else {
        return null
      }
    },
    displayNumberWithUnit(number, unit) {
      if (number == null || number == undefined) {
        return null
      } else {
        return `${this.roundNumber(number)} ${unit}`
      }
    },
    roundNumberK(number) {
      if (typeof number === "number") {
        return Math.round(number / 10) / 100
      } else {
        return null
      }
    },
    displayNumberWithUnitK(number, unit) {
      if (number == null || number == undefined) {
        return null
      } else {
        return `${this.roundNumberK(number)} ${unit}`
      }
    },
    convertMeterToMile(meter) {
      if (meter == null || meter == undefined) {
        return null
      } else {
        return Math.round(meter * 100 / 1852) / 100
      }
    },
    setFocusedVoyageIndex(value) {
      this.focusedVoyageIndex = value
    },
    selectVoyage(voyage, index) {
      if (!this.visibleVoyages.includes(index)) return

      if (this.selectedVoyageIndex == index) {
        this.selectedVoyageIndex = null
      } else {
        this.selectedVoyageIndex = index
        this.selectedVoyageData.pilot = voyage.pilot
        this.selectedVoyageData.vesselName = voyage.vesselName
      }
    },
    setLinePropertyFocused(targetLayer, isFocused) {
      if (isFocused) {
        this.map.setPaintProperty(
          targetLayer,
          "line-width",
          4
        )
        this.map.setPaintProperty(
          targetLayer,
          "line-opacity",
          1
        )
      } else {
        this.map.setPaintProperty(
          targetLayer,
          "line-width",
          2
        )
        this.map.setPaintProperty(
          targetLayer,
          "line-opacity",
          0.6
        )
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
#voyage-plan-compare {
  #voyage-plan-map {
    background: $aisea-dark-blue !important;
  }
  .voyage-plan-compare-inner {
    &.mobile {
      padding: 0;
      background: transparent;
      .select-box {
        width: 130px !important;
        margin-right: 10px !important;
      }
      .control-area-block {
        .vs-button {
          padding: 0.75rem 1rem;
        }
        .vs__search {
          max-width: 0px;
          max-height: 0px;
          margin: 0;
          padding: 0;
        }
      }
    }
  }
  .mapboxgl-ctrl-map-style-changer {
    height: 40px !important;
    width: 60px !important;
    .mapboxgl-ctrl-icon {
      border-radius: 4px;
    }
  }
  .back-to-list-button-area {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .back-to-list-button {
      display: flex;
      height: 20px;
      cursor: pointer;
      color: $aisea-blue !important;
    }
  }
  .upper-control-area {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;
    .control-area-block {
      display: flex;
      align-items: center;
      height: 42px;
      .control-area-label {
        margin-right: 15px;
        font-weight: bold;
      }
      .control-area-text {
        margin-right: 30px;
      }
      .select-box {
        width: 180px;
        margin-right: 30px;
      }
    }
  }
  .main-voyage-plan-container {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    &.mobile {
      min-height: 0px;
      display: block;
      .voyage-plan-map-wrapper {
        .data-display-container {
          top: 0px;
          left: 10px;
          position: absolute;
          border-radius: 5px;
        }
      }

      .voyage-plan-control-container {
        position: relative;
        #voyage-plan-map {
          width: 100%;
          height: calc(100vh - 250px);
        }
        .voyage-plan-control-area {
          margin: 0;
          border-radius: 0px !important;
          width: 100%;
          height: fit-content;
          flex-wrap: wrap;
          .control-area-switch-container {
            width: 100%;
            min-height: 44px;
          }
        }
      }
    }
    #voyage-plan-map {
      display: flex;
      flex-grow: 1;
      background: #BBB;
      height: calc(100vh - 150px);
      min-height: 231px;
    }
    .data-display-container {
      padding: 10px;
      color: #fff;
      background: rgba(44, 50, 65, 0.8);
      margin-top: 10px;
      width: 200px;
      border-radius: 0px 5px 5px 0px;
      .point-data-area {
        margin-bottom: 10px;
      }
      .data-text {
        height: 21px;
      }
    }
    .voyage-plan-control-container {
      position: absolute;
      display: flex;

      max-height: 100%;
      overflow-y: auto;
      .voyage-plan-control-area {
        z-index: 1;
        width: 190px;
        margin-left: 10px;
        margin-top: 10px;
        margin-bottom: 10px;
        height: fit-content;
        border-radius: 5px;
        background: rgba(44, 50, 65, 0.8);
        color: #fff;
        &.show-data {
          border-radius: 5px 0px 0px 5px;
        }
        .focused-route-info-text {
          min-height: 22px;
        }
        .control-area-title {
          padding: 15px 0px;
          margin: 0px 15px;
          border-bottom: 1px solid $aisea-gray;
        }
        .control-area-switch-container {
          padding: 4px 15px;
          border-bottom: 1px solid $aisea-gray;
          transition: 0.3s;
          position: relative;
          .click-event-wrapper{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
          &:hover {
            background: rgba(72,160,244, 0.4);
          }
          &.selected {
            background: rgba(72,160,244, 0.7);
          }
          &.inactive {
            background: rgba(79,79,79, 0.8);
            button {
              background: $aisea-gray !important;
            }
          }
          &.first {
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
          }
          &.last {
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            border-bottom: none;
          }
          .upper-switch-container {
            display: flex;
            align-items: center;
            padding: 8px 0px;
          }
          .control-switch {
            margin-left: auto;
          }
        }
      }
    }
  }

  // transition css
  .left-enter-active, .left-leave-active {
    transform: translate(0px, 0px);
    transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  }

  .left-enter, .left-leave-to {
    transform: translateX(-190px) translateX(0px);
  }
}

</style>
